import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "relative bg-white rounded-2xl max-w-3xl shadow-lg w-11/12 flex flex-col max-h-[90vh]" }
const _hoisted_2 = { class: "px-6 py-4 border-b border-gray-200" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-500" }

import { ref, computed } from 'vue';
import { TalentPoolForm, FormNavigation } from './talentPoolForm';
import { useTalentPoolsStore } from '@/stores/talentPoolsStore'
import { CircleX } from 'lucide-vue-next'
import { useProjectsStore } from '@/stores/projectsStore'
import { useTalentPoolModal } from '@/composables/useTalentPoolModal'

// ===================================
// 2. PROPS & EMITS
// ===================================

// ===================================
// 3. STATE
// ===================================

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateModal',
  setup(__props, { expose: __expose }) {

// ===================================
// 1. IMPORTS
// ===================================
const { open, formRef, wizardMeta, show, close } = useTalentPoolModal()
const talentPoolsStore = useTalentPoolsStore()
const projectsStore = useProjectsStore()

// ===================================
// 7. FUNCTIONS
// ===================================

const handleSave = async () => {
  if (!formRef.value) return
  const { form, newProject, projectMode, selectedProject, editor } = formRef.value as any

  let projectId: number | null = null

  if (form.type === 'project') {
    if (projectMode === 'existing' && selectedProject) {
      projectId = selectedProject.id
    } else if (projectMode === 'new') {
      const project = await projectsStore.createProject(newProject)

      if (!project) {
        console.error('Project creation failed. Aborting talent pool creation.')
        return
      }

      projectId = project.id
    }
  }

  // --- Build payload
  const talentPoolPayload = {
    type: form.type,
    location: form.location.address.trim(),
    location_lat: form.location.lat,
    location_lng: form.location.lng,
    title: form.title.trim(),
    description: editor.getJSON(),
    workType: form.workType,
    rate: form.salary,
    rateType: form.salaryType,
    hiring_timeline: form.hiringTimeline,
    timeline: form.hiringTimeline === 'specific_date' ? form.timeline : null,
    requirements: form.requirements,
    qualifications: form.qualifications,
    projectId,
  }

  // --- Submit to store
  await talentPoolsStore.createTalentPool(talentPoolPayload)

  // --- Reset form & close modal
//   if (formRef.value.resetForm) {
    // formRef.value.resetForm()
//   }

  close()
}


__expose({ show, close })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(open))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 flex items-center justify-center",
              onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)), ["esc"])),
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black/50",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
              }),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-900 leading-tight" }, " Create Talent Pool ", -1)),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(wizardMeta).label), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, " Step " + _toDisplayString(_unref(wizardMeta).step) + " of " + _toDisplayString(_unref(wizardMeta).total), 1),
                      _createVNode(_unref(CircleX), {
                        class: "h-6 w-6 text-gray-500 cursor-pointer",
                        onClick: _unref(close)
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _createVNode(_unref(TalentPoolForm), {
                  ref_key: "formRef",
                  ref: formRef,
                  mode: "edit",
                  "initial-data": null
                }, null, 512),
                (_unref(formRef))
                  ? (_openBlock(), _createBlock(_unref(FormNavigation), {
                      key: 0,
                      "can-proceed": _unref(formRef).canProceedToNextStep,
                      "is-first-step": _unref(formRef).currentStepIndex === 0,
                      "is-last-step": _unref(formRef).currentStepIndex === _unref(formRef).steps.length - 1,
                      onPrev: _cache[1] || (_cache[1] = ($event: any) => (_unref(formRef).decreaseStep())),
                      onNext: _cache[2] || (_cache[2] = ($event: any) => (_unref(formRef).increaseStep())),
                      onSubmit: handleSave,
                      onCancel: _unref(close)
                    }, null, 8, ["can-proceed", "is-first-step", "is-last-step", "onCancel"]))
                  : _createCommentVNode("", true)
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})